import { Component, createRef } from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { Icon } from '@winnin/winnin_ui.components.icon'

import Select from 'components/ReactSelect'

import localStorageUtils from '../../utils/localStorageUtils'

import './index.scss'

@observer
class InputAction extends Component {
  constructor(props) {
    super(props)
    this._change = this.change.bind(this)
    this._click = this.click.bind(this)
    this.input = createRef()
    this.searchTerms = localStorageUtils.getObject(this.props.searchKey)
  }

  keyPress = e => {
    if (e.key === 'Enter') {
      this.click(e)
    }
  }

  change() {
    const { onChange } = this.props
    if (this.input.current) {
      if (onChange) onChange(this.input.current.value)
    }
  }

  click() {
    const { onClick } = this.props
    if (this.input.current) {
      if (this.props.showDatalist) {
        this.handleSearchTerm(this.input.current.value)
      }
      if (onClick) onClick(this.input.current.value)
    }
  }

  renderIcon() {
    const { icon } = this.props
    if (icon) {
      return <Icon fill="var(--gray_dark2)" width={24} height={24} className="InputAction-icon" icon={icon} />
    }
    return null
  }

  handleSearchTerm(value) {
    const currentTerms = localStorageUtils.getObject(this.props.searchKey)
    if (!currentTerms) {
      const newTerms = [value]
      this.searchTerms = newTerms
      localStorageUtils.setObject(this.props.searchKey, newTerms)
      return
    }
    const newTerms = [value, ...currentTerms]
    if (currentTerms.includes(value)) {
      const deleteIndex = newTerms.lastIndexOf(value)
      newTerms.splice(deleteIndex, 1)
    }
    const finalArray = newTerms.length > 10 ? newTerms.slice(0, 10) : newTerms
    this.searchTerms = finalArray
    localStorageUtils.setObject(this.props.searchKey, finalArray)
  }

  render() {
    const {
      value,
      placeholder,
      className,
      languageSelector,
      onLanguageChange,
      languageSelectorOptions,
      languageSelectorValue,
      showDatalist,
      name,
      disabled = false,
    } = this.props
    const containerClass = classNames('input-action-container', { disabled }, className)

    return (
      <div className={containerClass}>
        <div className="input-wrapper">
          {languageSelector ? (
            <div className="language-selector">
              <Select
                className="filter"
                onChange={onLanguageChange}
                placeholder="Language"
                value={languageSelectorValue}
                name="select-filter-language"
                options={languageSelectorOptions}
                isSearchable={!languageSelector}
                icon="globe"
              />
              <div className="icon-wrapper">{this.renderIcon()}</div>
            </div>
          ) : (
            <div className="icon-wrapper">{this.renderIcon()}</div>
          )}
          <input
            data-hj-allow
            type="text"
            list="search-input"
            placeholder={placeholder}
            ref={this.input}
            onKeyPress={this.keyPress}
            onChange={this._change}
            value={value}
            name={name}
            disabled={disabled}
          />
          {showDatalist && (
            <datalist id="search-input">
              {this.searchTerms?.length > 0 && this.searchTerms?.map(item => <option value={item} key={item} />)}
            </datalist>
          )}
        </div>
      </div>
    )
  }
}

InputAction.propTypes = {}

InputAction.defaultProps = {
  placeholder: '',
  value: '',
  languageSelector: false,
  showDatalist: false,
  searchKey: 'video-search-terms',
}

InputAction.displayName = 'InputAction'

export default InputAction
